import { useI18n } from "@/api/i18n";
import {
  type LinkedInProfileErrorKind,
  mapLinkedInProfileError,
} from "./linkedin-error";
import { useProfileSkillWriteErrorMessage } from "./profile-skill-write-error-message";

export const useLinkedInProfileErrorMessage = () => {
  const { t } = useI18n();
  const profileSkillWriteErrorMessage = useProfileSkillWriteErrorMessage();

  return (
    error: unknown,
    fallbackMessage: string,
    options?: { skillWrite?: boolean },
  ): string => {
    const mapped = mapLinkedInProfileError(error, options);
    switch (mapped.kind) {
      case "invalid_request":
        return t("errors.linkedin.invalid_request") as string;
      case "not_found":
        return t("errors.linkedin.not_found") as string;
      case "server_error":
        return t("errors.linkedin.server_error") as string;
      case "generic":
        return mapped.message || fallbackMessage;
      default:
        return profileSkillWriteErrorMessage(
          mapped as Exclude<
            LinkedInProfileErrorKind,
            | { kind: "invalid_request" }
            | { kind: "not_found" }
            | { kind: "server_error" }
            | { kind: "generic"; message: string }
          >,
        );
    }
  };
};
